let env = process.env.NODE_ENV
let url=''//接口连接的地址
let dataPiontUrl = ''//数据上报的地址
import dataJson from '@/assets/json/data.json'
if(env=='development'){
    // 开发环境
    // url='http://172.16.1.180:7777'//本地开发地址
    url='https://docs7-service.awspaas.com'//paas开发地址
    dataPiontUrl = 'http://172.22.3.247:8088/r/w'
}else{
    url=dataJson.paas.axiosUrl
    dataPiontUrl = "https://my.awspaas.com/r/jd"
}
export default{
    url,
    dataPiontUrl
}